import {
  DialogDescription,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogClose,
  Dialog,
  Button,
} from '@ui/components';

import { useRemoveVehicleDialog } from './use-remove-vehicle-dialog';

interface RemoveVehicleDialogProps {
  isOpenForId: string | null;
  onClose: ({ handleSubmit }: { handleSubmit: boolean }) => void;
}

export const RemoveVehicleDialog = ({ isOpenForId, onClose }: RemoveVehicleDialogProps) => {
  const { removeVehicle, isPending, t } = useRemoveVehicleDialog(() =>
    onClose({ handleSubmit: true }),
  );

  return (
    <Dialog onOpenChange={() => onClose({ handleSubmit: false })} open={!!isOpenForId}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('VEHICLES.REMOVE_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('VEHICLES.REMOVE_DIALOG_DESCRIPTION')}</DialogDescription>
        <DialogFooter className="flex items-center justify-between gap-4">
          <DialogClose asChild>
            <Button variant="tertiary" wide>
              {t('VEHICLES.REMOVE_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => !!isOpenForId && removeVehicle(isOpenForId)}
            isLoading={isPending}
            variant="primary"
            wide
          >
            {t('VEHICLES.REMOVE_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
